// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__l24wa","label":"Completed_label__3bCA6"};